import { LacesAuthTokenService } from "app/services/infrastructure/laces-auth-token.service";
import { IPublicationVersion } from "app/services/config/app-config-loader.service";
import { sparqlExecute } from "../backend.service";

export interface SparqlEndpointAjaxOptions {
    url: string;
    mode: "get" | "post";
    auth: "basic" | "laces" | null;
    username: string;
    password: string;
    versions: IPublicationVersion[];
    backendUrl: string;
}

export type SparqlValue = {
    [varName: string]: {
        type: "literal" | "uri";
        value: any;
    };
};

export interface SparqlQueryParameter {
    name: string;
    type: "uri" | "text";
    value: string;
}

export type SparqlQueryParameters = SparqlQueryParameter[];

export interface ISparqlJsonResult {
    head: {
        vars: string[];
    };
    results: {
        distinct: boolean;
        ordered: boolean;
        bindings: SparqlValue[];
    };
}

export abstract class ISparqlExecutor {
    abstract execute(query: string, parameters: SparqlQueryParameters): Promise<ISparqlJsonResult>;
    abstract updateVersionUrl(url: string): void;
    abstract get versionUrl(): string;
}

export class AjaxSparqlExecutor implements ISparqlExecutor {
    private _versionUrl;

    constructor(private options: SparqlEndpointAjaxOptions) {
        this._versionUrl = options.url;
    }

    get versionUrl() {
        return this._versionUrl;
    }

    async updateVersionUrl(url: string) {
        this._versionUrl = url;
    }

    async execute(query: string, parameters: SparqlQueryParameters): Promise<ISparqlJsonResult> {
        for (const param of parameters) {
            const regExp = new RegExp(`\\?${param.name}`, "gi");
            switch (param.type) {
                case "uri":
                    query = query.replace(regExp, `<${param.value}>`);
                    break;
                case "text":
                    query = query.replace(regExp, `"${param.value}"`);
                    break;
            }
        }

        const headersObj: { [name: string]: string } = {
            Accept: "application/sparql-results+json"
        };
        let body: string | undefined;

        if (this.options.mode === "get") {
            this._versionUrl = this._versionUrl + "?query=" + this.properEncodeURIComponent(query);
        } else {
            body = query;
            headersObj["Content-Type"] = "application/sparql-query";
        }

        const response = await sparqlExecute(this._versionUrl, headersObj, body);

        if (!response?.data) {
            location.reload();
        }

        return response?.data;
    }

    private properEncodeURIComponent(s: string): string {
        return encodeURIComponent(s).replace(/'/gi, `%27`);
    }
}
